import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../index';
import { CanvasState } from '../../slices/canvas';

export const selectEditMode = (): any =>
    createSelector(
        (state: RootState) => state.canvas,
        (canvas: CanvasState) => canvas.editMode,
    );
